export default __webpack_public_path__ + "static/media/ntx-no-background.7feda2fb.png";